module.exports = __webpack_public_path__ + "img/Recurso 39@300x.eceaa570.png";